import React from 'react';
import { Button, Stack } from '@mui/material';

// Styles
import Styles from './SetupUserDrawerFooter.module.scss';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';
import { useUserDrawer } from '@Modal/hooks/users/useUserDrawer';
import { useDispatch } from 'react-redux';

export const SetupUserDrawerFooter: React.FC = () => {
  const dispatch = useDispatch();
  const { setShowDeleteUserModal, submittable, handleSubmitGeneralForm, handleCreateCancel } =
    useUserDrawer();
  const { userPermissions, currentUser } = useAuthorization();
  const permissionToManageUsers =
    userPermissions?.includes('CAN_EDIT_USERS') || currentUser?.isSuper;
  const permissionToDeleteUsers =
    userPermissions?.includes('CAN_DELETE_USERS') || currentUser?.isSuper;
  return (
    <Stack className={Styles.SetupUserDrawerFooter}>
      {permissionToManageUsers && (
        <Button
          className={Styles.SaveCTA}
          type="submit"
          disabled={!submittable}
          onClick={handleSubmitGeneralForm}
        >
          Save settings
        </Button>
      )}
      <Button className={Styles.CancelCTA} variant="outlined" onClick={handleCreateCancel}>
        Cancel
      </Button>
      {permissionToDeleteUsers && (
        <Button
          className={Styles.DeleteCTA}
          color="error"
          variant="contained"
          onClick={() => dispatch(setShowDeleteUserModal(true))}
        >
          Delete
        </Button>
      )}
    </Stack>
  );
};
